/**
 * Replaces characters by a symbol of choice
 * @param {string} string of characters
 * @param {string} symbol string representation of any symbol
 * @returns string
 */
const replaceCharBy = (string: string, symbol: string): string => string.replace(/./g, symbol);

export default replaceCharBy;